import { useState } from "react";
import { Button, Modal } from "flowbite-react";
import { declineTrocProposal } from "../../../services/callAPI/trocsPropositions";
import UnvalidToast from "../../toasts/UnvalidToast";
import ValidToast from "../../toasts/ValidToast";

interface IDeclineProposal {
  travTrocId: number;
  resTrocId: number;
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
}

function DeclineProposal(props: IDeclineProposal) {
  //destructuring
  const { travTrocId, resTrocId, setTrigUseEffect } = props;

  const [openModal, setOpenModal] = useState(false);
  const [openToastUnvalid, setopenToastUnvalid] = useState<boolean>(false);
  const [openToastValid, setopenToastValid] = useState<boolean>(false);
  const [errorMsg, seterrorMsg] = useState<string | undefined>(undefined);

  async function handleClickYes() {
    try {
      if (await declineTrocProposal(travTrocId, resTrocId) != 204) {
        throw new Error(`status is diferent of 204`);
      }

      setopenToastValid(true);//show validToast      

      const timer = setTimeout(() => {
        setTrigUseEffect(prev => !prev);
      }, 4000);

      //clean timer
      return () => clearTimeout(timer);

    } catch (error) {
      if (error instanceof Error) {
        seterrorMsg(error.message);//add error msg

        setopenToastUnvalid(true); //show unvalidToast

        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 3000);
      }
      else {
        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 3000);
      }
    }
    finally {
      setOpenModal(false); //close modal
    }
  }

  return (
    <>
      {openToastUnvalid &&
        <UnvalidToast
          onClose={() => {
            setopenToastUnvalid(false);
            seterrorMsg(undefined);
          }}
          message={errorMsg}
        />
      }
      {openToastValid && <ValidToast onClose={() => setopenToastValid(false)} />}

      <Button
        id="btn-cancel-proposal"
        onClick={() => setOpenModal(true)}
        className="bg-redCustom w-1/2 max-w-28"
      >
        Refuser
      </Button>

      <Modal
        show={openModal}
        size="md"
        onClose={() => setOpenModal(false)}
        popup
        className="bg-transparent backdrop-blur-sm"
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Je souhaite refuser le troc
            </h3>
            <div className="flex justify-center gap-4">
              <Button className="bg-greenCustom" onClick={() => handleClickYes()}>
                {"Oui, je suis sûr"}
              </Button>
              <Button className="bg-lightRedCustom" onClick={() => setOpenModal(false)}>
                Non, pas sûr
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default DeclineProposal;